export default "//file.bilionpass.com/japandx-portal/0.1.21/static/img/example-retail.9bced79b-66e13e.png";